import { Feature, Point } from "geojson"
import { SpecialVisualisationParams, SpecialVisualizationSvelte } from "../../SpecialVisualization"
import SvelteUIElement from "../../Base/SvelteUIElement"
import PointImportFlow from "./PointImportFlow.svelte"
import { PointImportFlowArguments, PointImportFlowState } from "./PointImportFlowState"
import { Utils } from "../../../Utils"
import { ImportFlowUtils } from "./ImportFlow"
import Translations from "../../i18n/Translations"
import { GeoOperations } from "../../../Logic/GeoOperations"
import Tr from "../../Base/Tr.svelte"
import { UIEventSource } from "../../../Logic/UIEventSource"
import { OsmTags } from "../../../Models/OsmFeature"

/**
 * The wrapper to make the special visualisation for the PointImportFlow
 */
export class PointImportButtonViz extends SpecialVisualizationSvelte {
    public readonly funcName = "import_button"
    public readonly docs: string =
        "This button will copy the point from an external dataset into OpenStreetMap" +
        ImportFlowUtils.documentationGeneral
    public readonly args: { name: string; defaultValue?: string; doc: string; split?: boolean }[] =
        [
            ...ImportFlowUtils.generalArguments,
            {
                name: "snap_onto_layers",
                doc: "If a way of the given layer(s) is closeby, will snap the new point onto this way (similar as preset might snap). To show multiple layers to snap onto, use a `;`-seperated list",
            },
            {
                name: "max_snap_distance",
                doc: "The maximum distance that the imported point will be moved to snap onto a way in an already existing layer (in meters). This is previewed to the contributor, similar to the 'add new point'-action of MapComplete",
                defaultValue: "5",
            },
            {
                name: "note_id",
                doc: "If given, this key will be read. The corresponding note on OSM will be closed, stating 'imported'",
            },
            {
                name: "maproulette_id",
                doc: "The property name of the maproulette_id - this is probably `mr_taskId`. If given, the maproulette challenge will be marked as fixed. Only use this if part of a maproulette-layer.",
            },
            {
                name: "to_point",
                doc: "If set, a feature will be converted to a centerpoint",
            },
        ]
    public needsUrls = []
    group = "data_import"

    constr({ state, tags, args, feature }: SpecialVisualisationParams): SvelteUIElement {
        const to_point_index = this.args.findIndex((arg) => arg.name === "to_point")
        const summarizePointArg = args[to_point_index].toLowerCase()
        if (feature.geometry.type !== "Point") {
            if (summarizePointArg !== "no" && summarizePointArg !== "false") {
                feature = GeoOperations.centerpoint(feature)
            } else {
                return new SvelteUIElement(Tr, {
                    t: Translations.t.general.add.import.wrongType.SetClass("alert"),
                })
            }
        }
        const baseArgs: PointImportFlowArguments = <any>Utils.ParseVisArgs(this.args, args)
        const tagsToApply = ImportFlowUtils.getTagsToApply(<UIEventSource<OsmTags>>tags, baseArgs)
        const importFlow = new PointImportFlowState(
            state,
            <Feature<Point>>feature,
            baseArgs,
            tagsToApply,
            tags
        )

        return new SvelteUIElement(PointImportFlow, {
            importFlow,
        })
    }
}
